import { StopInterface } from '../stops/types';

/*
 * Action Types
 */
export enum TerminalsTypes {
  LIST_TERMINALS_REQUEST = '@terminals/LIST_TERMINALS_REQUEST',
  LIST_TERMINALS_SUCCESS = '@terminals/LIST_TERMINALS_SUCCESS',
  LIST_TERMINALS_FAILURE = '@terminals/LIST_TERMINALS_FAILURE',

  GET_TERMINAL_REQUEST = '@terminals/GET_TERMINAL_REQUEST',
  GET_TERMINAL_SUCCESS = '@terminals/GET_TERMINAL_SUCCESS',
  GET_TERMINAL_FAILURE = '@terminals/GET_TERMINAL_FAILURE',

  FILTER_TERMINALS_REQUEST = '@terminals/FILTER_TERMINALS_REQUEST',
  FILTER_TERMINALS_SUCCESS = '@terminals/FILTER_TERMINALS_SUCCESS',
  FILTER_TERMINALS_FAILURE = '@terminals/FILTER_TERMINALS_FAILURE',

  CREATE_TERMINAL_REQUEST = '@terminals/CREATE_TERMINAL_REQUEST',
  CREATE_TERMINAL_SUCCESS = '@terminals/CREATE_TERMINAL_SUCCESS',
  CREATE_TERMINAL_FAILURE = '@terminals/CREATE_TERMINAL_FAILURE',

  UPDATE_TERMINAL_REQUEST = '@terminals/UPDATE_TERMINAL_REQUEST',
  UPDATE_TERMINAL_SUCCESS = '@terminals/UPDATE_TERMINAL_SUCCESS',
  UPDATE_TERMINAL_FAILURE = '@terminals/UPDATE_TERMINAL_FAILURE',

  DELETE_TERMINAL_REQUEST = '@terminals/DELETE_TERMINAL_REQUEST',
  DELETE_TERMINAL_SUCCESS = '@terminals/DELETE_TERMINAL_SUCCESS',
  DELETE_TERMINAL_FAILURE = '@terminals/DELETE_TERMINAL_FAILURE',

  GATE_UPDATE_REQUEST = '@terminals/GATE_UPDATE_REQUEST',

  LIST_TERMINAL_CONFIG_REQUEST = '@terminals/LIST_TERMINAL_CONFIG_REQUEST',
  LIST_TERMINAL_CONFIG_SUCCESS = '@terminals/LIST_TERMINAL_CONFIG_SUCCESS',
  LIST_TERMINAL_CONFIG_FAILURE = '@terminals/LIST_TERMINAL_CONFIG_FAILURE',

  UPDATE_TERMINAL_CONFIG_REQUEST = '@terminals/UPDATE_TERMINAL_CONFIG_REQUEST',
  UPDATE_TERMINAL_CONFIG_SUCCESS = '@terminals/UPDATE_TERMINAL_CONFIG_SUCCESS',
  UPDATE_TERMINAL_CONFIG_FAILURE = '@terminals/UPDATE_TERMINAL_CONFIG_FAILURE',
}

/*
 * Data types
 */
export interface BoundsInterface {
  lat: number;
  lng: number;
}

export interface ServicesInterface {
  id: string;
  garageId: string;
  title: string;
  bounds: BoundsInterface[];
}

export interface QuantityInterface {
  id: string;
  garageId: string;
  type: string;
  value: number;
}

export interface ResponsibleInterface {
  id: string;
  name: string;
  email: string;
}

export interface TerminalAddress {
  id: string;
  city: string;
  street: string;
  number: string;
  compl: string;
  state: string;
  neigh: string;
  cep: string;
  latitude: number;
  longitude: number;
  createdAt: string;
  updatedAt: string;
  TerminalAddress: {
    id: string;
    terminalId: string;
    addressId: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface SchedulesInterface {
  hours: {
    start: string;
    end: string;
  }[];
  weekdays: string[];
}

export interface BlocksInterface {
  id: string;
  name: string;
  type?: number;
  left?: number;
  top?: number;
  rotation?: number;
  zoom?: number;
  quantity?: number;
  Gates?: Array<any>;
  bounds: {
    lat: number;
    lng: number;
  }[];
  LineBlocks?: {
    Line: {
      id: string;
      name: string;
    };
  }[];
  associateLines: {
    id: string;
    name: string;
  }[];
  createdAt?: string;
  updatedAt?: string;
  terminalId?: string;
}

export interface TerminalInterface {
  id: string;
  name: string;
  phone: string;
  cnpj: string;
  Addresses: TerminalAddress[];
  bounds: BoundsInterface[];
  schedules: SchedulesInterface[];
  Blocks: BlocksInterface[];
  Stop?: StopInterface;
  createdAt: string;
  updatedAt: string;
  elevators: boolean;
  escalators: boolean;
  stairs: boolean;
  accessRamps: boolean;
  tactileFloor: boolean;
  publicToilets: boolean;
  suggestionBox: boolean;
  sink: boolean;
  accessibleSink: boolean;
  integrationStation: boolean;
  wifi: boolean;
  foodCourt: boolean;
  bikeStation: boolean;
  bikeRack: boolean;
  crashEvents?: string[];
  GarageQuantities: QuantityInterface[];
  GarageServices: ServicesInterface[];
  TransportSupervisor: ResponsibleInterface;
  openingType?: number;
  boardingOpening?: number;
  boardingClosure?: number;
}

export interface TerminalConfigInterface {
  id: string;
  name: string;
  shortName: string;
  terminalIps: string[];
}

/*
 * State type
 */
export interface TerminalsState {
  readonly terminalList: TerminalInterface[];
  readonly terminalData: TerminalInterface;
  readonly terminalConfigList: TerminalConfigInterface[];
  readonly terminalConfigData: TerminalConfigInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
